import { useIdle } from '@sanlam-glacier/app-common/hooks';
import { useAuth } from 'auth';
import { useConfig } from 'providers/config/ConfigProvider';
import { PropsWithChildren } from 'react';

export const IdleLogoutGuard = ({ children }: PropsWithChildren) => {
  const { logout } = useAuth();
  const { idleTimeoutSeconds } = useConfig();
  const idle = useIdle(idleTimeoutSeconds * 1000);

  if (idle) {
    logout().catch((err) => {
      // logout has error handling, so should something go wrong here
      // and you can't be logged out when you should, throw unhandled error
      // new Error to notify idle logout was the source
      throw new Error(err);
    });
  }
  return children;
};
